module.exports = __webpack_public_path__ + "img/抖音.39ef0725.png";